
/** Extracts universal mapped properties from paramTemplate data */
export const getUniversalMappedPoints = (paramTemplateData: any) => {
  if (!paramTemplateData) return {};
  const mappedPoints: Record<string, any> = {};
  Object.entries(paramTemplateData).forEach(([objectId, pointData]: [string, any]) => {
    if (pointData?.property) {
      mappedPoints[pointData.property] = {
        objectId,
        ...pointData
      };
    }
  });
  return mappedPoints;
};
  // Get values from operationalData for universal mapped points
export const getOperationalValue = (propertyKey: string, universalMappedPoints: any,dynamicOperationalData:any ) => {
    const point = universalMappedPoints[propertyKey];
    if (!point?.objectId) return null;
    const dataKey = `${point.objectId}/85`;
    return dynamicOperationalData[dataKey] ?? dynamicOperationalData[point.objectId] ?? null;
};

export const formatValue = (currentValue: any, config: any, systemEnum: any = null) => {
    // 1. Check if the value is in the propertyMapping (Universal Property logic)
    if (config?.propertyMapping) {
        const { propertyMapping } = config;
        // Reverse lookup: find the universal key (e.g. 0, 1) corresponding to the raw BACnet value
        const universalKey = Object.keys(propertyMapping).find(
            (key) => String(propertyMapping[key]) === String(currentValue)
        );

        if (universalKey !== undefined && systemEnum?.[universalKey]) {
            // Resolve the label from the system enum (e.g. index 0 -> "COOL")
            return systemEnum[universalKey];
        }
    }

    const numValue = Number(currentValue);
    // 2. Check if the value is a key for a custom enum (Manual mapping logic)
    if (config?.customEnum?.[numValue]) {
        return config?.customEnum[numValue];
    }
    if (isNaN(numValue)) {
        return currentValue;
    }
    return Number.isInteger(numValue) ? String(numValue) : numValue.toFixed(1);
};